module.exports = {"621221100":"城关镇","621221101":"黄渚镇","621221102":"红川镇","621221103":"小川镇","621221104":"纸坊镇","621221105":"抛沙镇","621221107":"店村镇","621221108":"王磨镇","621221109":"陈院镇","621221110":"沙坝镇","621221111":"黄陈镇","621221112":"鸡峰镇","621221113":"苏元镇","621221114":"索池镇","621221203":"宋坪乡","621221206":"二郎乡","621221213":"镡河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621221.json
// module id = 3094
// module chunks = 0